import React from 'react'

import { PageTitle } from "../../../../../_template/layout/core/PageData";

const Channels = () => {
    const loginUserType = localStorage.getItem('type');

    let pageTitle
    if(loginUserType === 'A'){
        pageTitle = [
            {
                title: 'Agents',
                path: '/agents',
                isSeparator: false,
                isActive: false,
            },
            {
                title: '',
                path: '',
                isSeparator: true,
                isActive: false,
            },
            {
                title: 'Guide',
                path: '/guide/overview',
                isSeparator: false,
                isActive: false,
            },
            {
                title: '',
                path: '',
                isSeparator: true,
                isActive: false,
            },
        ];
    }
    else if(loginUserType === 'D'){
        pageTitle = [
            {
                title: 'Agents',
                path: '/agents',
                isSeparator: false,
                isActive: false,
            },
            {
                title: '',
                path: '',
                isSeparator: true,
                isActive: false,
            },
        ];
    }
    
    return (
        <>
            <PageTitle breadcrumbs={pageTitle}>Channels</PageTitle>
            <div>Channels</div>
        </>
        
    )
}

export default Channels